import React, { useRef } from 'react';
import './card-glass.styles.scss';

const CardGlass = ({
  children,
  className = '',
  titleStringsList = [],
  subheading = '',
  variant = 'default',
  customBorderColor = null,
  noGradient = false
}) => {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;

    const rect = cardRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    cardRef.current.style.setProperty('--mouse-x', `${x}px`);
    cardRef.current.style.setProperty('--mouse-y', `${y}px`);
  };

  const handleMouseLeave = () => {
    if (!cardRef.current) return;

    cardRef.current.style.removeProperty('--mouse-x');
    cardRef.current.style.removeProperty('--mouse-y');
  };

  // Handle multiple variants (e.g., "teal large")
  const variants = variant
    .split(' ')
    .map((v) => `glass-card--${v}`)
    .join(' ');
  const cardClasses = `glass-card ${variants} ${className}`;

  const inlineStyles = {
    ...(customBorderColor ? { '--border-color': customBorderColor } : {}),
    ...(noGradient
      ? {
          '--border-gradient':
            'linear-gradient(135deg, var(--border-color) 0%, var(--border-color) 100%)'
        }
      : {})
  };

  return (
    <div
      ref={cardRef}
      className={cardClasses}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={inlineStyles}
    >
      {/* Dynamic blur overlay that follows mouse */}
      <div className="glass-card-blur-overlay" />

      {/* Content */}
      <div className="glass-card-content">
        {titleStringsList.length > 0 && (
          <h3 className="glass-card-title fs-h6">
            {titleStringsList.map((str, index) => (
              <span key={index}>{str}</span>
            ))}
          </h3>
        )}

        {subheading && <p className="glass-card-subheading">{subheading}</p>}

        {children}
      </div>
    </div>
  );
};

export default CardGlass;
